import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VersionUpdatePopup from 'components/common/VersionUpdatePopup';
import { Routing } from './Routing';
import ErrorBoundary from './pages/SinglePages/Error/ErrorBoundary';
import Theme from '../theme';
import Context from '../context';
import Redux from './Redux';

export default function App() {
  return (
    <Redux>
      <Theme>
        <VersionUpdatePopup>
          <ErrorBoundary>
            <Context>
              <Routing />
            </Context>
            <ToastContainer limit={3} position="top-center" rtl />
          </ErrorBoundary>
        </VersionUpdatePopup>
      </Theme>
    </Redux>
  );
}
